export enum SignQueueStatusEnum {
  NONE = 'NONE',
  PENDING = 'PENDING',
  SENT = 'SENT',
  SIGNED = 'SIGNED',
  REJECTED = 'REJECTED',
  ERRORED = 'ERRORED',
}
